import { render, staticRenderFns } from "./ed-course-content-sidebar.vue?vue&type=template&id=65cb2142&scoped=true&"
import script from "./ed-course-content-sidebar.ts?vue&type=script&lang=ts&"
export * from "./ed-course-content-sidebar.ts?vue&type=script&lang=ts&"
import style0 from "./ed-course-content-sidebar.scss?vue&type=style&index=0&id=65cb2142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cb2142",
  null
  
)

export default component.exports